import React from 'react';
import { FlexRow } from './components/basic/Flex';
import { Body2 } from './components/common';
import { useMessageGetter } from 'react-message-context';
import { useAppState } from './context/appContext';
import styled from 'styled-components/macro';
import { themeColors } from './theme/theme';

const SystemNotificationBanner = styled(FlexRow)`
  background-color: ${themeColors.charcoal80};
`;

const AppContainer: React.FC = ({ children }) => {
  const t = useMessageGetter('');
  const { systemNotification } = useAppState();
  const notificationText = systemNotification?.translationKey ? t(systemNotification.translationKey) : undefined;

  return (
    <>
      {notificationText && (
        <SystemNotificationBanner justifyContent="flex-end" padding="0 80px">
          <Body2 $color={themeColors.m2White}>{notificationText}</Body2>
        </SystemNotificationBanner>
      )}
      <>{children}</>
    </>
  );
};

export default AppContainer;
